import { useLoaderData } from "react-router-dom";

import ClientNotes from "../../../../../clientNotes/ClientNotes";
import { useEntityNotePermissions } from "../../../../../clientNotes/hooks/useEntityNotePermissions";

export default function EntityNotes() {
  const { id } = useLoaderData();

  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-y-auto rounded-[14px] bg-white p-6">
      <ClientNotes
        ownerId={id}
        notesRepositoryKey="repositories/entity-notes-repository"
        ownerQueryKey="entityId"
        includeOwnerInCreatePayload={false}
        hideNoteTypeSelector
        hideAISummary
        notePermissionsHook={useEntityNotePermissions}
      />
    </div>
  );
}
